import { FormContextValues, NumberPatternType } from '@dreryk/react-common';

import { isNull } from '~libs.typescript';

import { translationKeys } from '../../../translations';

import { GroupSessionsMinAgeFieldFormBeanPart } from './GroupSessionsMinAgeField.types';
import { StyledNumberInput } from './GroupSessionsMinAgeField.styled';

const MIN_AGE_MIN_VALUE = 1;
const MIN_AGE_STEP_VALUE = 1;
const MIN_AGE_DEFAULT_VALUE = 1;

type GroupSessionsMinAgeFieldProps = Pick<
   FormContextValues<GroupSessionsMinAgeFieldFormBeanPart>,
   'register' | 'getValue' | 'setValue'
>;

export const GroupSessionsMinAgeField = (props: GroupSessionsMinAgeFieldProps): JSX.Element => {
   return (
      <StyledNumberInput
         testId={'minAge'}
         controller={props.register('minAge', {
            validate: (value) => {
               const minAge = value as number | null;
               const maxAge = props.getValue('maxAge');

               if (isNull(minAge)) {
                  props.setValue('minAge', MIN_AGE_DEFAULT_VALUE);
                  return true;
               }

               if (minAge < MIN_AGE_MIN_VALUE) {
                  props.setValue('minAge', MIN_AGE_MIN_VALUE);
                  return true;
               }

               if (maxAge && minAge > maxAge) {
                  props.setValue('minAge', maxAge);
                  return true;
               }

               return true;
            },
            required: true,
         })}
         label={translationKeys.minAge}
         defaultValue={MIN_AGE_DEFAULT_VALUE}
         stepValue={MIN_AGE_STEP_VALUE}
         pattern={NumberPatternType.POSITIVE_INTEGER}
      />
   );
};
